<br>
<br>
<br>
<br>
<br>
<br>
<mat-stepper #stepper>
    <mat-step>
        <ng-template matStepLabel>Gestor de ciclos de encuestas</ng-template>
        <app-ciclos-mannager></app-ciclos-mannager>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Indicadores</ng-template>
        <app-indicadores></app-indicadores>
    </mat-step>
</mat-stepper>